import {Reader} from "../../entities/Reader";
import {PagingCtrl} from "../PagingCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import {CmdCenterSetPositionGatewayModel} from "../../models/cmd/CmdCenterSetPositionGatewayModel";

export class CmdCenterSetPositionGatewayCtrl extends PagingCtrl<Reader> {
    public static $inject = ['$scope', '$location', '$state', '$stateParams', '$uibModalInstance', 'CmdCenterSetPositionGatewayModel', 'NotificationService', 'vtagX', 'vtagY', 'vtagZ'];

    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService: StateParams,
                public modalInstance: angular.ui.bootstrap.IModalServiceInstance,
                public setPositionGatewayModel: CmdCenterSetPositionGatewayModel,
                public notificationService: NotificationService, vtagX: any, vtagY: any, vtagZ: any) {
        super($scope, $location, stateService, stateParamsService, setPositionGatewayModel, notificationService);
        this.setPositionGatewayModel.init(parseFloat(vtagX), parseFloat(vtagY), vtagZ);
    }

    Ok() {
        var x = this.setPositionGatewayModel.useMeters ? this.setPositionGatewayModel.x : this.setPositionGatewayModel.x / this.setPositionGatewayModel.feetPerMeter;
        var y = this.setPositionGatewayModel.useMeters ? this.setPositionGatewayModel.y : this.setPositionGatewayModel.y / this.setPositionGatewayModel.feetPerMeter;
        var gatewayName = this.setPositionGatewayModel.gatewayName;
        if (gatewayName != null && gatewayName.length > 0) {
            var gateway: Reader =
                new Reader(null, this.setPositionGatewayModel.gatewayName,
                    "", false);
            gateway.vTagX = x;
            gateway.vTagY = y;
            gateway.vTagZ = this.setPositionGatewayModel.z;
            this.modalInstance.close(gateway);
        }
    }

    Cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
